import React, { use, useEffect, useRef, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useSchool } from '../../DataStore/SchoolContext';
import { useTheme } from '../../DataStore/ThemeContext';
import Pagination from '../../components/Common/Pagination';
import { useFeesDefaulter } from '../../DataStore/FeesDefaulterContext';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import functions from '../../util/functions';
import DefaulterListHead from '../../components/SchoolFees/DefaulterListHead';
import printContent, { numberFormat } from '../../util/araknerdlib';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ImportDefaultersModal from '../../components/SchoolFees/ImportDefaultersModal';
import { useSchWalletBalance } from '../../DataStore/SchWalletBalanceContext';
import WalletBalanceListHead from '../../components/SchoolFees/WalletBalanceListHead';

const StudentWalletBalancePage = () => {

    const {notify, getClasses, getResidences} = useSchool();
    const {currentNotify} = useTheme();
    const {getbalanceListing, balanceListing, metaData, setCurrentPage, searchText} = useSchWalletBalance();
    const statementRef = useRef(); // Ref to enclose statement content for printing
    const [showImportModal, setShowImportModal] = useState(false);

    useEffect(()=>{
        getClasses();
        getResidences();
        if(!balanceListing){
            getbalanceListing();
        }
    }, [])

    const exportDefaultersToExcel = (rows = []) => {
  if (!Array.isArray(rows) || rows.length === 0) return;

  // Build flat data (clean columns)
  const data = rows.map((item, idx) => ({
    "#": idx + 1,
    "Student Name": item?.student?.full_name || "",
    "Gender": item?.student?.gender || "",
    "Reg No.": item?.student?.reg_no || "",
    "Class": item?.student?.class?.class_name || "",
    "Residence": item?.student?.residence?.residence_name || "",
    "Balance": Number(item?.balance || 0),
    "Home Contact": item?.student?.home_contact || "",
    "Payment Code": item?.student?.payment_code || "",
  }));

  const ws = XLSX.utils.json_to_sheet(data);

  // Set column widths (optional but makes it look professional)
  ws["!cols"] = [
    { wch: 4 },   // #
    { wch: 26 },  // Student Name
    { wch: 10 },  // Gender
    { wch: 14 },  // Reg No
    { wch: 12 },  // Class
    { wch: 16 },  // Residence
    { wch: 14 },  // Balance
    { wch: 16 },  // Home Contact
    { wch: 14 },  // Payment Code
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Wallet Balances");

  // Write to array buffer
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  const today = new Date().toISOString().slice(0, 10);
  const filename = `wallet_balances_${today}.xlsx`;

  saveAs(new Blob([wbout], { type: "application/octet-stream" }), filename);
};



   
// Filtered students based on searchText
const filteredTransactions = Array.isArray(balanceListing)
    ? balanceListing.filter(
            (transaction) =>
                transaction.student.full_name?.toLowerCase().includes(searchText.toLowerCase()) ||
                transaction.student.reg_no?.toLowerCase().includes(searchText.toLowerCase()) ||
                transaction.balance?.toLowerCase().includes(searchText.toLowerCase())

        )
    : [];


   

    const PageActions = ()=>(<>
         <ActionDropdownItem iconClass="fa fa-print" label="Print List" onClick={()=>printContent(statementRef, "Student Wallet Balances")}/>
        <ActionDropdownItem iconClass="fa fa-file-excel" label="Export to Excel" onClick={()=>exportDefaultersToExcel(filteredTransactions)}/>
        <ActionDropdownItem iconClass="fa fa-refresh" label="Refresh" onClick={()=>getbalanceListing(true)}/>
        </>)


    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Student Wallet Balances"
                    description="View student wallet balances."
                    iconClass="fa fa-wallet"
                    PageActions={PageActions}
                    sticky={true}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                        loadMore={false}
                /> : <></>}
                />
                {notify}
                {currentNotify}
                 <WalletBalanceListHead
                     handleExport={() => exportDefaultersToExcel(filteredTransactions)} 
                     />
                <div className="card">
                    <div className="card-body">

                      <div ref={statementRef} className='table-responsive'>
                        <table className="table table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Student Name</th>
                                    <th>Gender</th>
                                    <th>Reg No.</th>
                                    <th>Class</th>
                                    <th>Residence</th>
                                    <th>Balance</th>
                                    <th>Home Contact</th>
                                    <th>Payment Code</th>
                                </tr>
                            </thead>
                            <tbody>
                             {Array.isArray(filteredTransactions) && filteredTransactions.map((item)=>
                                <tr key={item.student.id}>
                                    <td>{item.student.full_name}</td>
                                    <td>{item.student.gender}</td>
                                    <td>{item.student.reg_no}</td>
                                    <td>{item.student.class?.class_name || ''}</td>
                                    <td>{item.student.residence?.residence_name || ''}</td>
                                    <td>{numberFormat(item.balance)}</td>
                                    <td>{item.student.home_contact}</td>
                                    <td>{item.student.payment_code}</td>

                                </tr>
                            )}

                            </tbody>
                        </table>
                        </div>
                    {!balanceListing && <ActivityLoader />}
                        {filteredTransactions.length === 0 && (
                            <Notification message="No wallet balance  record found." closable={false} />
                        )}
                    
                    </div>
                </div>               


               
                
            </MainContent>
        </PageContainer>
        <ImportDefaultersModal
            show={showImportModal}
            onClose={()=>setShowImportModal(false)}
            onImport={async()=>{await getbalanceListing(true);}}
        />
        </>
    );
};

export default StudentWalletBalancePage;
